import { SettlementFundAoAEnum } from '@interfaces/settlement-fund/settlement-fund.enum';
import { createAction, props } from '@ngrx/store';

export const appianSubmit = createAction('[Submit] Submitting to Appian');
export const internalTransferAppianSubmit = createAction(
  '[Submit] Submitting an Internal Transfer to Appian',
);
export const inheritedIraSubmit = createAction('[Submit] Submitting Inherited IRA to Appian');

export const cipSubmit = createAction('[Submit CIP] Creating Appian CIP document case');
export const submitFailed = createAction('[Submit] Failed');
export const submitCompleted = createAction('[Submit] Completed');
export const submitInProgress = createAction('[Submit] InProgress');
export const updateIsStp = createAction('[Submit] Update IsSTP', props<{ payload: boolean }>());
export const resetSubmitState = createAction('[Submit] Reset Submit State');
